const Dots = () => {
  const style = {
    display: "flex",
    placeItems: "center",
    placeContent: "center",
    width: "32px",
    height: "32px",
    color: "#757575",
  };

  return <span style={style}>...</span>;
};

export default Dots;
